import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Modal from 'components/Modal';
import { showModal, hideModal } from 'actions/modalActions';
import { hasChildItems } from 'components/CartItem/ChildItems';
import BuyBackDetails from 'pages/ProductPage/BuyBack/BuyBack';
import { withToast, TOAST_LEVELS } from 'components/Toast/Toast';
import styles from './CartBuyBack.css';
import Button from 'components/Button';
import StringWidget from 'components/StringWidget';
import SimpleImage from 'components/Common/Image/SimpleImage';
import getImageUrl from 'utils/getImageUrl';
import PriceWidget from 'components/PriceWidget';
import PlusPrice from 'components/PriceWidget/PlusPrice';
import omnitureHelper from 'utils/omnitureHelper';
import cx from 'classnames';
import Loader from 'components/Common/Loader/Loader';
import fdpHelper from 'utils/FDPHelper';
import ProductRatingWidget from 'components/ProductRatingWidget/ProductRatingWidget';
import fkAdvantageLogo from 'images/fa.png';

export class CartBuyBack extends Component {
	state = {
		addingInCart: false
	};
	// CartV4 Migration => Added new view Type DigitalAttachValue.

	getDigitalItem = recommendedItems => {
		return (
			recommendedItems &&
			recommendedItems.find(
				// ABB, EW and DIGITAL_ATTACH to be removed once V4 migration is complete
				item =>
					item.type === 'ABB' ||
					item.type === 'EW' ||
					item.type === 'DIGITAL_ATTACH' ||
					// New values starting here
					item.type === 'ABBValue' ||
					item.type === 'PhysicalAttachValue' ||
					item.type === 'DigitalAttachValue' ||
					item.type === 'ExtendedWarrantyValue'
			)
		);
	};

	trackAddToCart = () => {
		const { cartItem } = this.props;
		const { recommendedItems } = cartItem;
		const abbInfo = this.getDigitalItem(recommendedItems);
		const { userState, location } = this.props;
		const abb = [];
		abb.push({
			productId: get(abbInfo, ['productId']),
			listingId: get(abbInfo, ['listingId']),
			vertical: get(abbInfo, ['vertical']) || null,
			category: get(abbInfo, ['category']) || null,
			type: get(cartItem, ['productId'])
		});
		let recoItemType = abbInfo.type;
		const omniFields = {};
		if (recoItemType === 'EW') {
			omniFields.clickInfo = `cart_ew_attach_1_1`;
			omniFields.ew = abb;
		} else {
			omniFields.clickInfo = `cart_abb_attach_1_1`;
			omniFields.abb = abb;
		}
		omnitureHelper.trackAddToCart(omniFields, userState, location);
	};

	trackShowMore = (location, userState) => {
		const { cartItem } = this.props;
		const { recommendedItems } = cartItem;
		const abbInfo = this.getDigitalItem(recommendedItems);

		const omniFields = {};
		const omnievents = ['event1'];
		const omniContext = {};
		omniContext.pageName = 'PRODUCT';
		omniContext.pageType = `${abbInfo.type}_know_more`;

		const fields = Object.assign(
			{},
			omnitureHelper.getBaseOmnitureFields({
				pageName: omniContext.pageName,
				pageType: omniContext.pageType,
				location: location,
				userState: userState
			}),
			omniFields,
			{ events: omnievents.join(',') }
		);
		omnitureHelper.trackOmniturePageView(fields);
	};

	handleEWShowMore = () => {
		this.trackShowMore(this.props.location, this.props.userState);
	};

	handleABBShowMore = listing => () => {
		this.handleShowBuyBackModal(listing);
		this.trackShowMore(this.props.location, this.props.userState);
	};

	handleAddCartItem = (listing, mainProductListingId, abbInfo) => () => {
		// TODO: Cart Migration => this check we should remove later

		this.setState({ addingInCart: true });

		if (this.props.handleAddCartItem) {
			this.props.handleAddCartItem(listing, mainProductListingId);
			this.trackAddToCart();
		} else {
			const params = {
				parentContext: mainProductListingId,
				listing: listing,
				type: 'CART_ADD_DETAILS'
			};
			this.props.cartAction([params]).then(response => {
				this.setState({ addingInCart: false });

				const message = get(response, 'actionResponseContext.actionMessages.0.text');
				if (!get(response, 'actionSuccess')) {
					this.props.toast.show({
						message,
						ttl: 6000,
						level: TOAST_LEVELS.ERROR
					});
				} else {
					this.props.toast.show({
						message,
						ttl: 6000,
						level: TOAST_LEVELS.SUCCESS
					});
				}

				this.props.addChildItemTracking(response, abbInfo);
				fdpHelper.trackEvent(
					{
						en: 'ATCC',
						iid: fdpHelper.generateId(),
						lid: listing,
						ct: 'PAGE'
					},
					true
				);
			});
		}
	};

	renderRating = () => {
		const { cartItem } = this.props;
		const { recommendedItems } = cartItem;
		const abbInfo = this.getDigitalItem(recommendedItems);
		const rating = get(abbInfo, 'rating', null);
		const listingId = get(abbInfo, 'listingId', null);
		const pid = get(abbInfo, 'id', null);

		if (!rating) return null;

		return (
			<div className={styles['rating']}>
				<ProductRatingWidget
					product={{ value: { rating, listingId } }}
					pid={pid}
					containerClass={styles['rating-container']}
				/>
			</div>
		);
	};

	renderFALogo = () => {
		const { cartItem } = this.props;
		const { recommendedItems } = cartItem;
		const abbInfo = this.getDigitalItem(recommendedItems);
		const flipkartAdvantage = get(abbInfo, 'fAssured', false);

		if (!flipkartAdvantage) return null;

		return (
			<span className={cx(styles['fk-advantage'], styles['new-fk-advantage'], styles['cart-abb-fk-advantage'])}>
				<img height="15" src={fkAdvantageLogo} className={styles['fk-advantage-icon']} />
			</span>
		);
	};

	handleShowBuyBackModal = listing => {
		this.props.showModal(`buyback-modal-${listing}`);
	};

	renderSubtitle = titles => {
		const { subtitle, coSubtitle } = titles;
		if (coSubtitle || subtitle) {
			const subtitleContent = [coSubtitle || '', subtitle || ''].filter(x => x).join(',');
			return <div className={styles['cart-item-subtitle']}>{subtitleContent}</div>;
		}
		return null;
	};

	renderAssuredBuyback = () => {
		const { cartItem } = this.props;
		const { attachTitle, recommendedItems } = cartItem;
		const abbInfo = this.getDigitalItem(recommendedItems);
		const hasChildItemsInCart = hasChildItems(cartItem);
		const mainProductListingId = cartItem.listingId;
		const hyperlinkTxt = get(abbInfo, ['hyperlink', 'text']) || get(abbInfo, ['knowMore', 'value', 'text']);
		const hyperlinkUrl = get(abbInfo, ['hyperlink', 'url']) || get(abbInfo, ['knowMore', 'action', 'originalUrl']);
		const coinPrice = get(abbInfo, ['pricingInfo', 'plusPriceInfo']);
		const titles = get(abbInfo, 'titles') || {};
		const title = titles.title;

		const { addingInCart } = this.state;

		if (!hasChildItemsInCart && abbInfo) {
			const listing = abbInfo.listingId;
			// Note: ABBValue was added after V4 migration, Removing condition old code.
			// ABB is from V3
			const knowMoreLink =
				abbInfo.type === 'ABB' || abbInfo.type === 'ABBValue' ? (
					<span onClick={this.handleABBShowMore(listing)} className={styles['hyperlinktxt']}>
						{hyperlinkTxt}
					</span>
				) : (
					<a
						onClick={this.handleEWShowMore}
						href={hyperlinkUrl}
						className={styles['hyperlinktxt']}
						target="_blank"
						rel="noopener noreferrer"
					>
						{hyperlinkTxt}
					</a>
				);

			return (
				<div className={cx(styles['cart-abb-info'], styles['digital-attach-reco'])}>
					<div className={styles['cart-attach-title']}>{attachTitle}</div>
					<div className={styles['add-box']}>
						<SimpleImage
							src={getImageUrl(get(abbInfo, ['media', 'images', 0, 'url']), 144)}
							containerClass={styles['abb-image']}
							width={72}
							height={72}
						/>
						<div className={styles['cart-abb-container']}>
							<div className={styles['cart-abb-title']}>{title}</div>
							{titles && this.renderSubtitle(titles)}
							<div className={styles['cart-abb-rating-logo']}>
								{this.renderRating()}
								{this.renderFALogo()}
							</div>
							<PriceWidget
								pricing={abbInfo.pricingInfo}
								display={['selling-price', 'old-price', 'discount']}
								containerClassName={styles['price']}
							/>
							<PlusPrice plusPriceInfo={coinPrice} />
							<div className={styles['cart-abb-desc']}>
								{abbInfo.description}
								{knowMoreLink}
							</div>
						</div>
						<div className={styles['cart-abb-button']}>
							<Button
								className={cx(styles['orange-btn'], { [styles['loading']]: addingInCart })}
								onClick={this.handleAddCartItem(listing, mainProductListingId, abbInfo)}
								disabled={addingInCart}
							>
								{addingInCart && <Loader stroke="#fff" className={styles['loader-icon']} radius={20} width={5} />}
								<StringWidget strKey="addItem" />
							</Button>
						</div>
					</div>
					{this.props.modal === `buyback-modal-${listing}` && (
						<Modal active closeOnOverlayClick closeOnEscape closeButton manual overlayId="buyback-modal-overlay">
							<div>
								<BuyBackDetails hyperlinkUrl={hyperlinkUrl} />
							</div>
						</Modal>
					)}
				</div>
			);
		}

		return null;
	};

	render() {
		return this.renderAssuredBuyback();
	}
}

const mapDispatchToProps = {
	showModal,
	hideModal
};

function mapStateToProps(state) {
	return {
		modal: get(state.modal, 'id'),
		userState: state.userState
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withToast(CartBuyBack));
